import { render, staticRenderFns } from "./cancel.vue?vue&type=template&id=16c53d10&scoped=true"
import script from "./cancel.vue?vue&type=script&lang=js"
export * from "./cancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c53d10",
  null
  
)

export default component.exports